import { Mobile, Tablet, Desktop } from '../styles/Responsive';
import LoginForm from '../components/forms/LoginForm';
import ImgSlider from '../components/imgSlider/ImgSlider';
import './login.scss';

export default function Login(props) {

  return (
    <>
      <Mobile>
        <div className="m-loginContainer">
          <LoginForm getToken={props.getToken} />
        </div>
      </Mobile>
      <Tablet>
        <div className="t-loginContainer">
          <div className="t-loginContent__grid">
            <LoginForm getToken={props.getToken} />
            <ImgSlider />
          </div>
        </div>
      </Tablet>
      <Desktop>
        <div className="loginContainer">
          <ImgSlider />
          <LoginForm getToken={props.getToken} />
        </div>
      </Desktop>
    </>
  );
}
